import { render } from "./Downlink.vue?vue&type=template&id=2312912c&ts=true"
import script from "./Downlink.vue?vue&type=script&lang=ts"
export * from "./Downlink.vue?vue&type=script&lang=ts"

import "./Downlink.vue?vue&type=style&index=0&id=2312912c&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__